<template>
  <!--
    Tab:
      b-tabs:content-class ==
        .tabs > .tab-content
      b-tab:class ==
        .tabs > .tab-content > .tab-pane
      b-tabs:active-tab-class ==
        .tabs > .tab-content > .tab-pane.active 
  -->
  <b-tab
      :class="['flex-grow-1 h-0', { 'p-3': !isWideBodyContent }]"
      :lazy="lazy"
      :title-item-class="['d-flex', !isFirstTab ? 'ml-3' : '']"
      title-link-class="d-flex p-3 flex-column justify-content-center align-items-center rounded-1 gmb-feature-tabs-nav__item"
  >
    <template #title>
      <div class="d-flex align-items-center">
        <slot name="tabHeaderNavItemPicto"/>
        <FdText class="ml-1" fontSizeSmaller2 minContent tag="span" uppercase>{{
            headerTitleText
          }}
        </FdText>
      </div>
    </template>

    <div
        :class="[
        'd-flex flex-grow-1 h-0 flex-column',
        { 'rounded-tl-1': isWideBodyContent },
      ]"
    >
      <FdScroll y>
        <slot name="tabBody"/>
      </FdScroll>
    </div>
  </b-tab>
</template>

<script>
import FdScroll from "@/flexdesign/Scroll";
import FdText from "@/flexdesign/Text";

export default {
  name: "GmbTab",

  components: {
    FdScroll,
    FdText,
  },

  props: {
    body: String,
    headerTitleText: String,
    isFirstTab: Boolean,
    isWideBodyContent: Boolean,
    lazy: Boolean,
  },

  data() {
    return {};
  },

  computed: {},

  watch: {},

  beforeCreate() {
  },

  created() {
  },

  beforeMount() {
  },

  mounted() {
  },

  beforeUpdate() {
  },

  updated() {
  },

  beforeUnmount() {
  },

  unmounted() {
  },

  methods: {},
};
</script>

<style lang="scss"></style>
